export { default as LocationQuery } from './LocationQuery';